export const ADD_TEAM_MEMBERS_DIALOG_OPEN = 'ADD_TEAM_MEMBERS_DIALOG_OPEN';
export const ADD_TEAM_MEMBERS_DIALOG_CLOSE = 'ADD_TEAM_MEMBERS_DIALOG_CLOSE';

export function openAddTeamMembersDialog() {
  return {
    type: ADD_TEAM_MEMBERS_DIALOG_OPEN,
  };
}

export function closeAddTeamMembersDialog() {
  return {
    type: ADD_TEAM_MEMBERS_DIALOG_CLOSE,
  };
}
export const MANAGE_TEAM_OBSERVERS_DIALOG_OPEN =
  'MANAGE_TEAM_OBSERVERS_DIALOG_OPEN';
export const MANAGE_TEAM_OBSERVERS_DIALOG_CLOSE =
  'MANAGE_TEAM_OBSERVERS_DIALOG_CLOSE';

export function openManageTeamObserversDialog() {
  return {
    type: MANAGE_TEAM_OBSERVERS_DIALOG_OPEN,
  };
}

export function closeManageTeamObserversDialog() {
  return {
    type: MANAGE_TEAM_OBSERVERS_DIALOG_CLOSE,
  };
}
